export enum FileFields {
    fileSize = 'FILESIZE',
    extension = 'SUFFIX',
    fileName = 'EXTFILEDES',
    fileData = 'EXTFILENAME',
    userName = 'USERLOGIN',
    lockUser = 'LUSERLOGIN',
    noSend = 'NOSEND',
    status = 'STATUS',
    fileDate = 'CURDATE',
    dataExchange = 'EI_COND'
}

export enum MailboxSendFields {
    fileSize = '',
    extension = '',
    fileName = 'ATTACHMENT',
    fileData = 'ATTACHMENT',
    userName = '',
    lockUser = '',
    noSend = '',
    status = '',
    fileDate = '',
    dataExchange = ''
}

export enum FileStatus {
    readOnly = 'R'
}
